import t from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const h = {
  display: "block"
}, m = ({ size: a = 16, useVw: i, useRem: o, color: l, withColor: n, removeClassName: e, disableSSR: x, style: c, ...d }) => {
  const p = c ? { ...h, ...c } : h;
  return /* @__PURE__ */ t.createElement(g, { disableSSR: x }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "32px-jiegouxinglicai", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: i ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), height: i ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: p, fill: "none", ...d }, /* @__PURE__ */ t.createElement(
    "g",
    {
      className: e ? "" : "32px-ç»ææ§çè´¢"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        className: e ? "" : "normal",
        d: "M17.792 6.126a2.833 2.833 0 0 0-3.584 0l-6.767 5.526a2.833 2.833 0 0 0-1.04 2.194V23.1a2.833 2.833 0 0 0 2.832 2.833h4.9a.967.967 0 0 0 .967-.966V22.21h-1.702a.9.9 0 1 1 0-1.8h3.956a.982.982 0 1 0 0-1.964h-2.94a2.782 2.782 0 1 1 0-5.564h.69v-1.233a.9.9 0 0 1 1.8 0v1.233h1.466a.9.9 0 0 1 0 1.8h-3.957a.982.982 0 0 0 0 1.964h2.941a2.782 2.782 0 1 1 0 5.564H16.9v2.757a2.767 2.767 0 0 1-2.767 2.766h-4.9A4.633 4.633 0 0 1 4.6 23.1v-9.254c0-1.391.625-2.709 1.703-3.589l6.766-5.526a4.633 4.633 0 0 1 5.862 0l6.766 5.526a4.633 4.633 0 0 1 1.703 3.589V23.1a4.633 4.633 0 0 1-4.633 4.633h-2.693a.9.9 0 1 1 0-1.8h2.693A2.833 2.833 0 0 0 25.6 23.1v-9.254c0-.85-.382-1.656-1.041-2.194l-6.767-5.526Z",
        fill: n ? r(l, 0, "#262933") : "#262933",
        datafollowfill: n ? r(l, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = m;
export {
  E as default
};
